<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{grayMode: grayActive}"
  >
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div
        class="d2-theme-header"
        :style="{
          opacity: this.searchActive ? 0.5 : 1
        }"
        flex-box="0"
        flex
      >
        <div
          class="logo-group"
          :style="{width: asideCollapse ? asideWidthCollapse : asideWidth}"
          flex-box="0"
        >
          <img v-if="asideCollapse" class="img-logo-only" src="./imgs/logo-only.png" />
          <img v-else class="img-logo-all" src="./imgs/logo-all.png" />

          <!-- <img
            v-if="asideCollapse"
            :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/icon-only.png`"
          />
          <img v-else :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`" />-->
        </div>
        <div class="toggle-aside-btn operation" @click="handleToggleAside" flex-box="0">
          <img src="./imgs/operation.png" alt />
        </div>
        <!-- <div class="refresh-btn">
          <img src="./imgs/refresh.png" alt />
        </div>-->
        <d2-menu-header class="menu-header" flex-box="1" />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <!-- <d2-header-search @click="handleSearchClick" /> -->
          <!-- 当前时间 -->
          <div class="current-time">{{time |formatDate}}</div>
          <div class="user-img">
            <img src="./imgs/user.png" alt />
          </div>
          <d2-header-user />
          <div class="user-img drop-down">
            <img src="./imgs/drop-down.png" alt />
          </div>
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1
          }"
        >
          <d2-menu-side />
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex>
          <!-- 搜索 -->
          <transition name="fade-scale">
            <div v-show="searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <d2-panel-search ref="panelSearch" @close="searchPanelClose" />
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div v-show="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <!-- tab -->
              <div class="d2-theme-container-main-header" flex-box="0">
                <d2-tabs separator-class="el-icon-arrow-right" />
              </div>
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view />
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import mixinSearch from "./mixins/search";
export default {
  name: "d2-layout-header-aside",
  mixins: [mixinSearch],
  components: {
    "d2-menu-side": () => import("./components/menu-side"),
    "d2-menu-header": () => import("./components/menu-header"),
    "d2-tabs": () => import("./components/tabs"),
    "d2-header-fullscreen": () => import("./components/header-fullscreen"),
    // "d2-header-search": () => import("./components/header-search"),
    "d2-header-size": () => import("./components/header-size"),
    "d2-header-theme": () => import("./components/header-theme"),
    "d2-header-user": () => import("./components/header-user"),
    "d2-header-error-log": () => import("./components/header-error-log")
  },
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: "220px",
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: "65px",
      time: new Date(),
      timer: null
    };
  },
  mounted() {
    this.getDate();
  },

  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let week = date.getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return `${y}年${MM}月${d}日  ${getWeek}  ${h}:${m}:${s}`;
    }
  },

  computed: {
    ...mapState("d2admin", {
      keepAlive: state => state.page.keepAlive,
      grayActive: state => state.gray.active,
      transitionActive: state => state.transition.active,
      asideCollapse: state => state.menu.asideCollapse
    }),
    ...mapGetters("d2admin", {
      themeActiveSetting: "theme/activeSetting"
    }),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...(this.themeActiveSetting.backgroundImage
          ? {
              backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
            }
          : {})
      };
    }
  },
  methods: {
    ...mapActions("d2admin/menu", ["asideCollapseToggle"]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside() {
      this.asideCollapseToggle();
    },
    getDate() {
      let _this = this;
      this.timer = setInterval(() => {
        _this.time = new Date();
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
.current-time {
  height: 70px;
  line-height: 70px;
  margin-right: 110px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.toggle-aside-btn {
  img {
    margin-top: 2px;
    vertical-align: middle;
  }
}

.refresh-btn {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  img {
    vertical-align: middle;
  }
}
.user-img {
  img {
    vertical-align: middle;
  }
}
.drop-down img {
  transform: translateX(-15px);
}
.d2-layout-header-aside-group {
  background-image: none !important;
  background-color: white !important;
}
.d2-theme-header {
  height: 70px !important;
  display: flex;
  align-items: center;
  position: relative !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07) !important;
}
// 菜单
.menu-header {
  width: 100%;
  height: 64px;
  position: absolute;
  top: 73px;
  left: 0;
  background: rgba(255, 255, 255, 1);
}
// 头部右侧
.d2-header-right {
  height: 70px !important;
  line-height: 70px !important;
  position: absolute;
  top: 0;
  right: 0;
}
//tab整体
.d2-theme-container {
  transform: translateY(60px);
}

// 注册主题
@import "~@/assets/style/theme/register.scss";
// 左上角logo
.d2-layout-header-aside-group
  .d2-layout-header-aside-content
  .d2-theme-header
  .logo-group
  img {
  height: 36px;
  vertical-align: middle;
}
.img-logo-only{
  width: 36px;
  height: 36px;
  vertical-align: middle;
}
.img-logo-all{
  width: 165px;
  height: 36px;
  vertical-align: middle;
}


.theme-tx1 .d2-theme-header .el-menu .el-menu-item:hover {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}

.theme-tx1
  .d2-theme-header
  .el-menu
  .el-submenu.is-active
  .el-submenu__title:hover {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
.theme-tx1 .d2-theme-header .el-menu .el-submenu.is-active .el-submenu__title {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}

.theme-tx1 .d2-theme-header .el-menu .el-menu-item.is-active {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
.el-menu-item.is-hover {
  color: #02b90d !important;
}
.el-submenu__title {
  color: #545454 !important;
}
.theme-tx1 .d2-theme-header .el-menu .el-submenu.is-active .el-submenu__title {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}

.theme-tx1
  .d2-theme-container
  .d2-theme-container-main
  .d2-theme-container-main-header
  .d2-multiple-page-control
  .el-tabs__nav
  .el-tabs__item.is-active {
  color: #02b90d;
  background-color: #fff;
  border-bottom-color: #fff;
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item.is-active {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item:hover {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
// icon

.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item.is-active
  i {
  color: #02b90d;
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item.is-active
  i:hover {
  color: #02b90d;
}
.theme-tx1 .d2-theme-header .toggle-aside-btn i:hover {
  color: #02b90d;
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item:hover
  i {
  color: #02b90d;
}
.theme-tx1
  .d2-theme-header
  .d2-theme-header-menu
  .d2-theme-header-menu__prev:hover,
.theme-tx1
  .d2-theme-header
  .d2-theme-header-menu
  .d2-theme-header-menu__next:hover {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
.theme-tx1
  .d2-theme-header
  .el-menu
  .el-submenu
  .el-submenu__title:hover
  .el-submenu__icon-arrow {
  color: #02b90d;
}
.theme-tx1 .d2-theme-header .el-menu .el-menu-item.is-active i.fa::before {
  display: none !important;
}
.fa-file-o:before {
  // content: "\F016";
  display: none;
}
.theme-tx1 .d2-theme-header .el-menu .el-submenu .el-submenu__title i.fa {
  display: none;
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-submenu
  .el-submenu__title:hover {
  color: #02b90d !important;
}
.d2-layout-header-aside-group
  .d2-layout-header-aside-content
  .d2-theme-container
  .d2-theme-container-aside
  .d2-layout-header-aside-menu-side {
  background: rgba(249, 249, 249, 1);
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item {
  border-left: 3px solid rgba(249, 249, 249, 1);
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-menu
  .el-menu-item.is-active {
  border-left: 3px solid #02b90d;
}
.theme-tx1 .d2-theme-header .el-menu .el-menu-item:focus {
  color: #02b90d;
  background: rgba(255, 255, 255, 0.5);
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-submenu
  .el-submenu__title:hover
  i {
  color: #02b90d;
}
.theme-tx1
  .d2-theme-container
  .d2-theme-container-aside
  .el-submenu
  .el-submenu__title:hover
  .el-submenu__icon-arrow {
  color: #02b90d;
}
</style>
